// src/pages/dashboard/components/TotalRobots.js
import React, { useState, useEffect } from 'react';

const TotalRobots = () => {
  const [totalRobots, setTotalRobots] = useState(0);

  useEffect(() => {
    // Simulate API call to fetch total robots
    const fetchTotalRobots = async () => {
      const response = await fetch('/api/total-robots'); // Replace with real API endpoint
      const data = await response.json();
      setTotalRobots(data.total);
    };

    fetchTotalRobots();
  }, []);

  return (
    <div>
      <h3>Total Robots</h3>
      <p>Total Active Robots: {totalRobots}</p>
    </div>
  );
};

export default TotalRobots;
